<template>
  <div class="page-section">
    <springter-section-1 v-if="section == 'springter-section-1'"></springter-section-1>
    <springter-section-2 v-if="section == 'springter-section-2'"></springter-section-2>
    <springter-section-3 v-if="section == 'springter-section-3'"></springter-section-3>
    <springter-section-4 v-if="section == 'springter-section-4'"></springter-section-4>
    <springter-section-5 v-if="section == 'springter-section-5'"></springter-section-5>
    <springter-section-6 v-if="section == 'springter-section-6'"></springter-section-6>
    <springter-section-7 v-if="section == 'springter-section-7'"></springter-section-7>
    <springter-section-8 v-if="section == 'springter-section-8'"></springter-section-8>
  </div>
</template>

<script>
import SpringterSection1 from './SpringterSection1';
import SpringterSection2 from './SpringterSection2';
import SpringterSection3 from './SpringterSection3';
import SpringterSection4 from './SpringterSection4';
import SpringterSection5 from './SpringterSection5';
import SpringterSection6 from './SpringterSection6';
import SpringterSection7 from './SpringterSection7';
import SpringterSection8 from './SpringterSection8';

export default {
  name: 'page-section',
  components: {
    SpringterSection1,
    SpringterSection2,
    SpringterSection3,
    SpringterSection4,
    SpringterSection5,
    SpringterSection6,
    SpringterSection7,
    SpringterSection8,
  },
  props: ['section'],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
};
</script>

<style lang="scss">
    .springter-section{
      padding-top: 15px;
      padding-bottom: 15px;
      height: 100%;
    } 

    .page-section{
      height: 100%;
    }

    .section-content {
      padding: 20px;

      @include mq('tablet-wide', 'max') {
        padding: 0;
      }

      @include mqlandscape(){
        padding: 0;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/PageSection.vue